import { render, staticRenderFns } from "./myTable.vue?vue&type=template&id=60057836&"
import script from "./myTable.vue?vue&type=script&lang=js&"
export * from "./myTable.vue?vue&type=script&lang=js&"
import style0 from "./myTable.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports